var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneIcon = function SvgPhoneIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 15,
    x: 0.5,
    fill: "#C4DFFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3583DF",
    d: "M7.693 14.216H1.442a.694.694 0 0 1-.7-.688V1.324c0-.38.313-.688.7-.688h6.251c.387 0 .7.307.7.688v12.204a.695.695 0 0 1-.7.688zM1.687 0C.853 0 .178.356.178 1.639V13.36C.178 14.644.853 15 1.687 15h5.787c.833 0 1.508-.356 1.508-1.639V1.64C8.982.356 8.307 0 7.474 0H1.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B72C6",
    d: "M5.38 1.219H3.62a.095.095 0 0 1-.098-.094c0-.052.043-.094.098-.094h1.76c.055 0 .098.042.098.094a.095.095 0 0 1-.098.094zM5.265 13.25h-1.37a.287.287 0 0 0-.293.282c0 .155.131.281.293.281h1.37a.287.287 0 0 0 .293-.281.287.287 0 0 0-.293-.281z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-icon.3f5bfaf869b47fec2a81243457627c01.svg";